import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { useMemo } from 'react';
import { ToastBar, resolveValue } from 'react-hot-toast';
import classNames from 'classnames';
import { Button } from '../../Button/Button.es.js';
import { Icon } from '../../Icon/Icon.es.js';

const Toast = ({ toast, onDismiss, position, locale })=>{
    const { className, message, ...rest } = toast;
    const localeWithFallback = useMemo(()=>({
            dismiss: 'Dismiss toast',
            ...locale
        }), [
        locale
    ]);
    return jsx(ToastBar, {
        position: position,
        toast: {
            className: classNames('cb-toast', className),
            message,
            ...rest
        },
        children: ({ icon })=>jsxs(Fragment, {
                children: [
                    jsxs("div", {
                        className: "content",
                        ...toast.ariaProps,
                        children: [
                            icon,
                            typeof message === 'string' ? jsx("div", {
                                className: "title",
                                children: message
                            }) : resolveValue(message, toast)
                        ]
                    }),
                    jsx(Button, {
                        className: "close-button",
                        label: localeWithFallback.dismiss,
                        onClick: onDismiss,
                        size: "sm",
                        variant: "secondary",
                        iconOnly: true,
                        children: jsx(Icon, {
                            className: "close-icon",
                            name: "XSolid",
                            size: 24
                        })
                    })
                ]
            })
    });
};
Toast.displayName = 'Toast';

export { Toast, Toast as default };
//# sourceMappingURL=Toast.es.js.map
